/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IamPermission
 */
export interface IamPermission {
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamPermission
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamPermission
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    shortName?: string;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    accessChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    apiPath?: string;
    /**
     * 
     * @type {string}
     * @memberof IamPermission
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IamPermission
     */
    statusDate?: Date;
}

export function IamPermissionFromJSON(json: any): IamPermission {
    return IamPermissionFromJSONTyped(json, false);
}

export function IamPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IamPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'updatedBy': !exists(json, 'updated_by') ? undefined : json['updated_by'],
        'shortName': !exists(json, 'short_name') ? undefined : json['short_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'accessChannelId': !exists(json, 'access_channel_id') ? undefined : json['access_channel_id'],
        'apiPath': !exists(json, 'api_path') ? undefined : json['api_path'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDate': !exists(json, 'status_date') ? undefined : (new Date(json['status_date'])),
    };
}

export function IamPermissionToJSON(value?: IamPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'updated_by': value.updatedBy,
        'short_name': value.shortName,
        'description': value.description,
        'access_channel_id': value.accessChannelId,
        'api_path': value.apiPath,
        'status': value.status,
        'status_date': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
    };
}


